import React from 'react';
import { Hero } from './components/Hero';
import { Features } from './components/Features';
import { Testimonials } from './components/Testimonials';
import { Pricing } from './components/Pricing';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white text-black selection:bg-[#ff0000] selection:text-white" data-id="element-0">
      {/* Top Bar */}
      <header className="border-b-2 border-black p-4 md:px-8 flex justify-between items-center sticky top-0 bg-white z-50" data-id="element-1">
        <div className="font-bold text-xl tracking-tighter" data-id="element-2">BUTINEURJEU_</div>
        <div className="flex gap-4 text-sm font-bold" data-id="element-3">
          <span className="hidden md:inline text-[#ff0000] animate-pulse" data-id="element-4">
            ● SYSTEM_ACTIVE
          </span>
          <span className="border border-black px-2 hover:bg-black hover:text-white cursor-pointer transition-colors" data-id="element-5">
            LOGIN
          </span>
        </div>
      </header>

      <main data-id="element-6">
        <Hero data-id="element-7" />
        <Features data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Pricing data-id="element-10" />
      </main>

      <Footer data-id="element-11" />
    </div>;
}